import { c as _c } from "react/compiler-runtime";
import type { BigIntish } from '@morpho-org/blue-sdk';
import { safeParseNumber } from '@morpho-org/blue-sdk-viem';
import { toBigInt } from '@morpho-org/dapp-core';
import { isDefined } from '@morpho-org/morpho-ts';
import { memo, useMemo } from 'react';
import { formatFeePercent, formatPendingManagementFee, getParsedValue } from '@/helpers/formatters';
import { getTimelockFunctionConfig } from '../utils';
import { StyledVaultPendingTimelock } from '../VaultV2PendingTimelockStyled';
import VaultPendingTimelockHeader from './VaultV2PendingTimelockHeader';
interface VaultV2PendingTimelockChangeManagementFeeProps {
  functionName: string;
  currentValue?: number;
  newValue?: BigIntish;
}
const VaultV2PendingTimelockChangeManagementFee = t0 => {
  const $ = _c(19);
  const {
    functionName,
    newValue,
    currentValue
  } = t0;
  let t1;
  if ($[0] !== functionName) {
    t1 = getTimelockFunctionConfig({
      functionName
    });
    $[0] = functionName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    label,
    criticality
  } = t1;
  let t2;
  if ($[2] !== newValue) {
    t2 = formatPendingManagementFee(toBigInt(newValue));
    $[2] = newValue;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const formattedNewValue = t2;
  let t3;
  if ($[4] !== currentValue) {
    t3 = formatFeePercent(getParsedValue(currentValue, safeParseNumber));
    $[4] = currentValue;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const formattedCurrentValue = t3;
  let t4;
  if ($[6] !== criticality || $[7] !== label) {
    t4 = <VaultPendingTimelockHeader title={label} criticality={criticality} />;
    $[6] = criticality;
    $[7] = label;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== currentValue || $[10] !== formattedCurrentValue) {
    t5 = isDefined(currentValue) && <StyledVaultPendingTimelock.Row><span className="text-2xs text-foreground">Current fee</span><span className="text-2xs text-foreground">{formattedCurrentValue}</span></StyledVaultPendingTimelock.Row>;
    $[9] = currentValue;
    $[10] = formattedCurrentValue;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="text-2xs text-foreground">New fee</span>;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== formattedNewValue) {
    t7 = <StyledVaultPendingTimelock.Row>{t6}<span className="text-2xs text-foreground">{formattedNewValue}</span></StyledVaultPendingTimelock.Row>;
    $[13] = formattedNewValue;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t4 || $[16] !== t5 || $[17] !== t7) {
    t8 = <div className="flex flex-col">{t4}{t5}{t7}</div>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
};
export default memo(VaultV2PendingTimelockChangeManagementFee);